module.exports = __webpack_public_path__ + "models/scene2adults.5d4b0a9.txt";